/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

var isInProcess = false;

function setProcess(process) {
    isInProcess = process;
}

function startProcess(view, options) {
    setProcess(true);
    view.defaultTab = options.panel || null;
}

function update(view, model, options) {
    view.update(options);

    return model.update(options);
}

function process(view, model, options) {
    var dfr = null;
    if (!isInProcess) {
        startProcess(view, options);

        view.updateTarget(options);

        if (!options.isLightbox && options.toggle && view.isOpen()) {
            view.close();
            setProcess(false);
        } else {
            dfr = update(view, model, options).always(Odigeo._.partial(setProcess, false));
        }
    }
    return Odigeo._.isNull(dfr) ? $.Deferred().resolve() : dfr.promise();
}

module.exports = Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_details').AccommodationDetailsModel,

    viewClass: require('../modules/views/accommodation_details'),

    isInProcess: Odigeo._.constant(isInProcess),

    execute: function(fun) {
        /* eslint complexity: ["error", 10] */
        var args = Odigeo._.rest(arguments);

        switch (fun) {
            case 'process':
                return process(this.view, this.model, Odigeo._.first(args));
            case 'closeDetails':
                return this.view.close.apply(this.view, args);
            case 'getRoomContainer':
                return this.view.getRoomContainer();
            case 'setRoomSelectionTestPartition':
                return this.view.setRoomSelectionTestPartition(args[0]);
            case 'clear':
                return this.model.clear();
        }

        return this;
    },
});
